export default __webpack_public_path__ + "static/icon-2-079e04b08d2a774ec2b250b4029d687c.png";